export const FETCH_WISHLIST = 'wishlist/FETCH'
export const FETCH_WISHLIST_SUCCESS = `${FETCH_WISHLIST}_SUCCESS`
export const FETCH_WISHLIST_FAIL = `${FETCH_WISHLIST}_FAIL`

export const ADD_TO_WISHLIST = 'wishlist/ADD'
export const ADD_TO_WISHLIST_SUCCESS = `${ADD_TO_WISHLIST}_SUCCESS`
export const REMOVE_FROM_WISHLIST = 'wishlist/REMOVE'
export const REMOVE_FROM_WISHLIST_SUCCESS = `${REMOVE_FROM_WISHLIST}_SUCCESS`

const initialState = { isLoading: false, products: [] }

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WISHLIST:
      return { ...state, isLoading: true }
    case FETCH_WISHLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        products: action.payload.data.map(({ skuId }) => skuId)
      }
    case FETCH_WISHLIST_FAIL:
      return { ...state, isLoading: false }
    case ADD_TO_WISHLIST_SUCCESS:
      return {
        ...state,
        products: [
          ...state.products,
          action.meta.previousAction.sku
        ]
      }
    case REMOVE_FROM_WISHLIST_SUCCESS:
      return {
        ...state,
        products: state.products.filter(sku => sku !== action.meta.previousAction.sku)
      }
    default: return state
  }
}

export const fetchWishlist = () => ({
  type: FETCH_WISHLIST,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'GET',
      url: '/v1/participants/me/wishlist'
    }
  }
})

export const fetchSimpleWishlist = () => ({
  type: FETCH_WISHLIST,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'GET',
      url: '/v1/participants/me/simplewishlist'
    }
  }
})

export const addToWishlist = sku => ({
  type: ADD_TO_WISHLIST,
  sku,
  payload: {
    request: {
      method: 'PUT',
      url: `/v1/participants/me/wishlist/${sku}/add`
    }
  }
})

export const removeFromWishlist = sku => ({
  type: REMOVE_FROM_WISHLIST,
  sku,
  payload: {
    request: {
      method: 'DELETE',
      url: `/v1/participants/me/wishlist/${sku}/remove`
    }
  }
})



// WEBPACK FOOTER //
// ./src/Wishlist/ducks.js